const translation = {
  nav: {
    home: '首页',
    category: '分类',
    about: '关于我们',
    subscribe: '订阅追踪',
    search: '搜索爆料...',
  },
  home: {
    heroTitle1: '网红黑料 · 明星塌房',
    heroTitle2: '每日吃瓜第一时间追踪',
    heroDesc: '911爆料网实时覆盖网红黑料、明星塌房现场与每日吃瓜爆料事件，第一时间追踪网络热门爆点，不延迟不掉线。',
    heroCta: '立即追踪',
    hotTitle: '全网热门追踪',
    hotSubtitle: '最新最热的爆料内容，实时更新中',
    viewMore: '查看全部',
    heatUnit: '热度',
    reviewLabel: '网友锐评',
    reviewTitle1: '每一个爆料背后',
    reviewTitle2: '都有真相在等待',
    ctaTitle: '不错过任何一个瓜',
    ctaSubtitle: '订阅911爆料网，第一时间获取网红黑料、明星塌房、每日吃瓜推送',
    ctaButton: '立即订阅追踪',
    dailyTitle: '今日追踪动态',
    dailySubtitle: '实时更新的爆料线索',
    readMore: '阅读全文',
    minRead: '分钟阅读',
  },
  footer: {
    brandDesc: '911爆料网 — 网红黑料、明星塌房、每日吃瓜爆料追踪平台。做最有态度的娱乐资讯。',
    categories: '内容分类',
    about: '关于我们',
    followUs: '关注我们',
    copyright: '© 2026 911爆料网 版权所有',
    privacy: '隐私政策',
    terms: '用户协议',
  },
  about: {
    title: '关于911爆料网',
    subtitle: '网红黑料 · 明星塌房 · 每日吃瓜 — 做最有态度的娱乐爆料平台',
    brandIntro: '品牌介绍',
    reputation: '用户口碑',
    contact: '联系我们',
    contactEmail: '合作/投稿邮箱',
    contactWechat: '微信公众号',
    contactWeibo: '官方微博',
    contactAddress: '公司地址',
  },
  category: {
    title: '内容分类',
    subtitle: '按分类浏览你最感兴趣的爆料内容',
    allArticles: '全部文章',
    noArticles: '暂无相关内容',
  },
  article: {
    breadcrumbHome: '首页',
    breadcrumbCategory: '分类',
    relatedArticles: '相关爆料',
    prevArticle: '上一篇',
    nextArticle: '下一篇',
    publishedOn: '发布于',
    source: '来源',
    sourceName: '911爆料网编辑部',
  },
  seo: {
    siteTitle: '911爆料网 911爆料网官网-911爆料网入口 | 网红黑料明星塌房每日吃瓜爆料追踪',
    siteDesc: '911爆料网官网与911爆料网入口实时覆盖网红黑料、明星塌房现场与每日吃瓜爆料事件，第一时间追踪网络热门爆点，不延迟不掉线。',
    siteKeywords: '911爆料网,911爆料网站,911爆料,911吃瓜爆料,911吃瓜爆料网,911爆料吃瓜,911黑料爆料,网红黑料,吃瓜爆料,每日爆料',
  },
};

export default translation;